export const SET_QUOTE_CONTACT = "quote.SET_QUOTE_CONTACT";
export const REQUEST_GENERATE_QUOTE = "quote.REQUEST_GENERATE_QUOTE";
export const RECEIVE_GENERATE_QUOTE = "quote.RECEIVE_GENERATE_QUOTE";
